import * as React from "react";
import { Navigate } from "react-router-dom";
import AuthService from "@/services/AuthService";

/**
 * VelaroAdminRoute — gates a route to Velaro-employee identities only (site 1032).
 *
 * This is an IDENTITY gate (per-user), NOT a subscription/feature gate (per-tenant).
 * Use it to wrap routes that expose Velaro-internal tooling — our own billing,
 * QuickBooks ledger mapping, Stripe (our payment processor) settings, superadmin
 * pages, dev tools, etc. Customers must never reach these pages even by typing the
 * URL directly.
 *
 * Hiding the sidebar entry is not sufficient — the route still resolves and renders
 * if a customer visits the URL. This wrapper hard-redirects non-Velaro identities.
 *
 * Backend endpoints these pages call MUST also enforce `IsVelaroAdminAsync()` —
 * frontend gates are bypassable. This wrapper is defense-in-depth, not the only
 * defense.
 *
 * Usage in Routes.tsx:
 *   {
 *     path: "/billing/settings",
 *     element: (
 *       <VelaroAdminRoute>
 *         <RouteHeader title="Stripe Settings"><BillingStripeSettings /></RouteHeader>
 *       </VelaroAdminRoute>
 *     )
 *   }
 */
export function VelaroAdminRoute({ children }: { children: React.ReactNode }) {
  if (AuthService.profile?.siteId !== 1032) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}

export default VelaroAdminRoute;
